import { useLocalReactionStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import WizardDialog, { WizardModalDialogProps } from "designSystem/components/wizard/WizardDialog";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import HiggMaterialComposition from "./HiggMaterialComposition";
import HiggMaterialForm from "./HiggMaterialForm";
import { HiggMaterialStore, HiggMaterialStoreContext } from "./HiggMaterialStore";

const NewHiggMaterialWizard: FunctionComponent<WizardModalDialogProps<HiggMaterialStore>> = observer((props) => {
	const {
		actionController,
		onSave,
		onClose,
		...otherProps
	} = props;

	const loc = useLocale();
	const store = useLocalReactionStore(() => new HiggMaterialStore(actionController, onClose, onSave, loc));
	const { index } = store || {};

	return (
		<>
			{store && (
				<HiggMaterialStoreContext.Provider value={store}>
					<WizardDialog
						{...otherProps}
						contentPadding={index === 0 ? null : 0}
						contentScrollable={false}
						// do this to prevent the MUI event from disabling the event of Dojo widget, for example, in the case of Form, when we try to select a value from drop-down, 
						// the focus event from MUI would disable the onMouseUp event of FilteringSelect widget
						disableEnforceFocus
						fullHeight={index === 1}
						pages={[HiggMaterialForm, HiggMaterialComposition]}
						store={store}
						supportStepInformation
						width={index === 1 ? 1200 : null}
					/>
				</HiggMaterialStoreContext.Provider>
			)}
		</>
	);
});

export default NewHiggMaterialWizard;